"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ContentLine_1 = require("../contentLine/ContentLine");
var preferredConsultantStyles_1 = require("./preferredConsultantStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var PreferredConsultant = function (_a) {
    var name = _a.name;
    var style = preferredConsultantStyles_1.default();
    return (<core_1.Box data-test="summary:container:preferred_consultant" className={style.wrapper}>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.title}>
            <Translation_1.default id={'trans__checkout__confirmation_page__summary__consultant_title'}/>
          </core_1.Typography>} dataTest="summary:preferred_consultant:title"/>
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={style.preferredConsultant}>
            {name}
          </core_1.Typography>} dataTest="summary:preferred_consultant:name" className={style.element}/>
    </core_1.Box>);
};
exports.default = PreferredConsultant;
